import { Schema } from "effect";
import {
  ConversationId,
  ConversationThreadId,
  DraftMessageId,
  MessageId,
} from "../../../ids/definitions";
import { MongoUserId } from "../../../ids/mongo-ids";
import { Attachment } from "./message/attachment";

export const SaveDraftInput = Schema.Struct({
  threadId: ConversationThreadId,
  inReplyToMessageId: Schema.optional(MessageId),
  content: Schema.String,
  attachments: Schema.Array(Attachment),
});

export type SaveDraftInput = typeof SaveDraftInput.Type;

export const DraftResponse = Schema.Struct({
  id: DraftMessageId,
  conversationId: ConversationId,
  threadId: ConversationThreadId,
  inReplyToMessageId: Schema.OptionFromUndefinedOr(MessageId),
  senderMongoUserId: MongoUserId,
  content: Schema.String,
  attachments: Schema.Array(Attachment),
  createdAt: Schema.DateTimeUtc,
  updatedAt: Schema.DateTimeUtc,
});

export type DraftResponse = typeof DraftResponse.Type;

export const ThreadDraftsResponse = Schema.Struct({
  drafts: Schema.Array(DraftResponse),
});

export type ThreadDraftsResponse = typeof ThreadDraftsResponse.Type;

export const SendMessageInput = Schema.Struct({
  threadId: ConversationThreadId,
  content: Schema.String,
  draftId: Schema.optional(DraftMessageId),
  attachments: Schema.Array(Attachment),
  inReplyToMessageId: MessageId,
});

export type SendMessageInput = typeof SendMessageInput.Type;

export class NotImplementedError extends Schema.TaggedError<NotImplementedError>()(
  "NotImplementedError",
  { message: Schema.String },
) {}
